module.exports = __webpack_public_path__ + "static/media/Gotham-BookItalic.ee15e85d.otf";


//////////////////
// WEBPACK FOOTER
// ./public/assets/fonts/Gotham Fonts/Gotham-BookItalic.otf
// module id = 1322
// module chunks = 0